var _g, _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect6, _rect7, _path9, _path10, _rect8, _rect9, _path11, _rect10, _rect11, _path12, _path13, _rect12, _rect13, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerIllustration({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1164,
    height: 694,
    viewBox: "0 0 1164 694",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_3673_579)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.5 0H326.25V86.75H239.5V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.25 86.0271H239.5V87.4729H326.25V86.0271Z",
    fill: "white",
    mask: "url(#path-1-inside-1_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.25 0H413V86.75H326.25V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.25 86.75H325.527V87.4729H326.25V86.75ZM413 86.0271H326.25V87.4729H413V86.0271ZM326.973 86.75V0H325.527V86.75H326.973Z",
    fill: "white",
    mask: "url(#path-3-inside-2_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413 0H499.75V86.75H413V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M413 86.75H412.277V87.4729H413V86.75ZM499.75 86.0271H413V87.4729H499.75V86.0271ZM413.723 86.75V0H412.277V86.75H413.723Z",
    fill: "white",
    mask: "url(#path-5-inside-3_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-4_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.75 0H586.5V86.75H499.75V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M499.75 86.75H499.027V87.4729H499.75V86.75ZM586.5 86.0271H499.75V87.4729H586.5V86.0271ZM500.473 86.75V0H499.027V86.75H500.473Z",
    fill: "white",
    mask: "url(#path-7-inside-4_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-5_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M586.5 0H673.25V86.75H586.5V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M586.5 86.75H585.777V87.4729H586.5V86.75ZM673.25 86.0271H586.5V87.4729H673.25V86.0271ZM587.223 86.75V0H585.777V86.75H587.223Z",
    fill: "white",
    mask: "url(#path-9-inside-5_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-6_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M673.25 0H760V86.75H673.25V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M673.25 0H760V86.75H673.25V0Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.25 86.75H672.527V87.4729H673.25V86.75ZM760 86.0271H673.25V87.4729H760V86.0271ZM673.973 86.75V0H672.527V86.75H673.973Z",
    fill: "white",
    mask: "url(#path-11-inside-6_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-7_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M760 0H846.75V86.75H760V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M760 86.75H759.277V87.4729H760V86.75ZM846.75 86.0271H760V87.4729H846.75V86.0271ZM760.723 86.75V0H759.277V86.75H760.723Z",
    fill: "white",
    mask: "url(#path-13-inside-7_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-8_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M846.75 0H933.5V86.75H846.75V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M846.75 86.75H846.027V87.4729H846.75V86.75ZM933.5 86.0271H846.75V87.4729H933.5V86.0271ZM847.473 86.75V0H846.027V86.75H847.473Z",
    fill: "white",
    mask: "url(#path-15-inside-8_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-17-inside-9_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.5 86.75H326.25V173.5H239.5V86.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.25 172.777H239.5V174.223H326.25V172.777Z",
    fill: "white",
    mask: "url(#path-17-inside-9_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-19-inside-10_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.25 86.75H413V173.5H326.25V86.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.25 173.5H325.527V174.223H326.25V173.5ZM413 172.777H326.25V174.223H413V172.777ZM326.973 173.5V86.75H325.527V173.5H326.973Z",
    fill: "white",
    mask: "url(#path-19-inside-10_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-21-inside-11_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413 86.75H499.75V173.5H413V86.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M413 86.75H499.75V173.5H413V86.75Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413 173.5H412.277V174.223H413V173.5ZM499.75 172.777H413V174.223H499.75V172.777ZM413.723 173.5V86.75H412.277V173.5H413.723Z",
    fill: "white",
    mask: "url(#path-21-inside-11_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-23-inside-12_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.75 86.75H586.5V173.5H499.75V86.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M499.75 173.5H499.027V174.223H499.75V173.5ZM586.5 172.777H499.75V174.223H586.5V172.777ZM500.473 173.5V86.75H499.027V173.5H500.473Z",
    fill: "white",
    mask: "url(#path-23-inside-12_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-25-inside-13_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M586.5 86.75H673.25V173.5H586.5V86.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M586.5 173.5H585.777V174.223H586.5V173.5ZM673.25 172.777H586.5V174.223H673.25V172.777ZM587.223 173.5V86.75H585.777V173.5H587.223Z",
    fill: "white",
    mask: "url(#path-25-inside-13_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-27-inside-14_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M673.25 86.75H760V173.5H673.25V86.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M673.25 173.5H672.527V174.223H673.25V173.5ZM760 172.777H673.25V174.223H760V172.777ZM673.973 173.5V86.75H672.527V173.5H673.973Z",
    fill: "white",
    mask: "url(#path-27-inside-14_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-29-inside-15_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M760 86.75H846.75V173.5H760V86.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M760 173.5H759.277V174.223H760V173.5ZM846.75 172.777H760V174.223H846.75V172.777ZM760.723 173.5V86.75H759.277V173.5H760.723Z",
    fill: "white",
    mask: "url(#path-29-inside-15_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-31-inside-16_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M846.75 86.75H933.5V173.5H846.75V86.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M846.75 173.5H846.027V174.223H846.75V173.5ZM933.5 172.777H846.75V174.223H933.5V172.777ZM847.473 173.5V86.75H846.027V173.5H847.473Z",
    fill: "white",
    mask: "url(#path-31-inside-16_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-33-inside-17_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.5 173.5H326.25V260.25H239.5V173.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.25 259.527H239.5V260.973H326.25V259.527Z",
    fill: "white",
    mask: "url(#path-33-inside-17_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-35-inside-18_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.25 173.5H413V260.25H326.25V173.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.25 260.25H325.527V260.973H326.25V260.25ZM413 259.527H326.25V260.973H413V259.527ZM326.973 260.25V173.5H325.527V260.25H326.973Z",
    fill: "white",
    mask: "url(#path-35-inside-18_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-37-inside-19_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413 173.5H499.75V260.25H413V173.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M413 260.25H412.277V260.973H413V260.25ZM499.75 259.527H413V260.973H499.75V259.527ZM413.723 260.25V173.5H412.277V260.25H413.723Z",
    fill: "white",
    mask: "url(#path-37-inside-19_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-39-inside-20_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.75 173.5H586.5V260.25H499.75V173.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M499.75 260.25H499.027V260.973H499.75V260.25ZM586.5 259.527H499.75V260.973H586.5V259.527ZM500.473 260.25V173.5H499.027V260.25H500.473Z",
    fill: "white",
    mask: "url(#path-39-inside-20_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-41-inside-21_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M586.5 173.5H673.25V260.25H586.5V173.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M586.5 260.25H585.777V260.973H586.5V260.25ZM673.25 259.527H586.5V260.973H673.25V259.527ZM587.223 260.25V173.5H585.777V260.25H587.223Z",
    fill: "white",
    mask: "url(#path-41-inside-21_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-43-inside-22_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M673.25 173.5H760V260.25H673.25V173.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M673.25 173.5H760V260.25H673.25V173.5Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.25 260.25H672.527V260.973H673.25V260.25ZM760 259.527H673.25V260.973H760V259.527ZM673.973 260.25V173.5H672.527V260.25H673.973Z",
    fill: "white",
    mask: "url(#path-43-inside-22_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-45-inside-23_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M760 173.5H846.75V260.25H760V173.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M760 260.25H759.277V260.973H760V260.25ZM846.75 259.527H760V260.973H846.75V259.527ZM760.723 260.25V173.5H759.277V260.25H760.723Z",
    fill: "white",
    mask: "url(#path-45-inside-23_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-47-inside-24_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M846.75 173.5H933.5V260.25H846.75V173.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M846.75 260.25H846.027V260.973H846.75V260.25ZM933.5 259.527H846.75V260.973H933.5V259.527ZM847.473 260.25V173.5H846.027V260.25H847.473Z",
    fill: "white",
    mask: "url(#path-47-inside-24_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-49-inside-25_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.5 260.25H326.25V347H239.5V260.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M239.5 260.25H326.25V347H239.5V260.25Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.25 346.277H239.5V347.723H326.25V346.277Z",
    fill: "white",
    mask: "url(#path-49-inside-25_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-51-inside-26_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.25 260.25H413V347H326.25V260.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.25 347H325.527V347.723H326.25V347ZM413 346.277H326.25V347.723H413V346.277ZM326.973 347V260.25H325.527V347H326.973Z",
    fill: "white",
    mask: "url(#path-51-inside-26_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-53-inside-27_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413 260.25H499.75V347H413V260.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M413 347H412.277V347.723H413V347ZM499.75 346.277H413V347.723H499.75V346.277ZM413.723 347V260.25H412.277V347H413.723Z",
    fill: "white",
    mask: "url(#path-53-inside-27_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-55-inside-28_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.75 260.25H586.5V347H499.75V260.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M499.75 260.25H586.5V347H499.75V260.25Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.75 347H499.027V347.723H499.75V347ZM586.5 346.277H499.75V347.723H586.5V346.277ZM500.473 347V260.25H499.027V347H500.473Z",
    fill: "white",
    mask: "url(#path-55-inside-28_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-57-inside-29_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M586.5 260.25H673.25V347H586.5V260.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M586.5 347H585.777V347.723H586.5V347ZM673.25 346.277H586.5V347.723H673.25V346.277ZM587.223 347V260.25H585.777V347H587.223Z",
    fill: "white",
    mask: "url(#path-57-inside-29_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-59-inside-30_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M673.25 260.25H760V347H673.25V260.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M673.25 347H672.527V347.723H673.25V347ZM760 346.277H673.25V347.723H760V346.277ZM673.973 347V260.25H672.527V347H673.973Z",
    fill: "white",
    mask: "url(#path-59-inside-30_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-61-inside-31_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M760 260.25H846.75V347H760V260.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M760 347H759.277V347.723H760V347ZM846.75 346.277H760V347.723H846.75V346.277ZM760.723 347V260.25H759.277V347H760.723Z",
    fill: "white",
    mask: "url(#path-61-inside-31_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-63-inside-32_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M846.75 260.25H933.5V347H846.75V260.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M846.75 347H846.027V347.723H846.75V347ZM933.5 346.277H846.75V347.723H933.5V346.277ZM847.473 347V260.25H846.027V347H847.473Z",
    fill: "white",
    mask: "url(#path-63-inside-32_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-65-inside-33_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.5 347H326.25V433.75H239.5V347Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.25 433.027H239.5V434.473H326.25V433.027Z",
    fill: "white",
    mask: "url(#path-65-inside-33_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-67-inside-34_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.25 347H413V433.75H326.25V347Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.25 347H413V433.75H326.25V347Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.25 433.75H325.527V434.473H326.25V433.75ZM413 433.027H326.25V434.473H413V433.027ZM326.973 433.75V347H325.527V433.75H326.973Z",
    fill: "white",
    mask: "url(#path-67-inside-34_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-69-inside-35_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413 347H499.75V433.75H413V347Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M413 433.75H412.277V434.473H413V433.75ZM499.75 433.027H413V434.473H499.75V433.027ZM413.723 433.75V347H412.277V433.75H413.723Z",
    fill: "white",
    mask: "url(#path-69-inside-35_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-71-inside-36_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.75 347H586.5V433.75H499.75V347Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M499.75 433.75H499.027V434.473H499.75V433.75ZM586.5 433.027H499.75V434.473H586.5V433.027ZM500.473 433.75V347H499.027V433.75H500.473Z",
    fill: "white",
    mask: "url(#path-71-inside-36_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-73-inside-37_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M586.5 347H673.25V433.75H586.5V347Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M586.5 433.75H585.777V434.473H586.5V433.75ZM673.25 433.027H586.5V434.473H673.25V433.027ZM587.223 433.75V347H585.777V433.75H587.223Z",
    fill: "white",
    mask: "url(#path-73-inside-37_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-75-inside-38_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M673.25 347H760V433.75H673.25V347Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M673.25 433.75H672.527V434.473H673.25V433.75ZM760 433.027H673.25V434.473H760V433.027ZM673.973 433.75V347H672.527V433.75H673.973Z",
    fill: "white",
    mask: "url(#path-75-inside-38_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-77-inside-39_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M760 347H846.75V433.75H760V347Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M760 347H846.75V433.75H760V347Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760 433.75H759.277V434.473H760V433.75ZM846.75 433.027H760V434.473H846.75V433.027ZM760.723 433.75V347H759.277V433.75H760.723Z",
    fill: "white",
    mask: "url(#path-77-inside-39_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-79-inside-40_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M846.75 347H933.5V433.75H846.75V347Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M846.75 433.75H846.027V434.473H846.75V433.75ZM933.5 433.027H846.75V434.473H933.5V433.027ZM847.473 433.75V347H846.027V433.75H847.473Z",
    fill: "white",
    mask: "url(#path-79-inside-40_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-81-inside-41_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.5 433.75H326.25V520.5H239.5V433.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.25 519.777H239.5V521.223H326.25V519.777Z",
    fill: "white",
    mask: "url(#path-81-inside-41_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-83-inside-42_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.25 433.75H413V520.5H326.25V433.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.25 520.5H325.527V521.223H326.25V520.5ZM413 519.777H326.25V521.223H413V519.777ZM326.973 520.5V433.75H325.527V520.5H326.973Z",
    fill: "white",
    mask: "url(#path-83-inside-42_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-85-inside-43_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413 433.75H499.75V520.5H413V433.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M413 520.5H412.277V521.223H413V520.5ZM499.75 519.777H413V521.223H499.75V519.777ZM413.723 520.5V433.75H412.277V520.5H413.723Z",
    fill: "white",
    mask: "url(#path-85-inside-43_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-87-inside-44_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.75 433.75H586.5V520.5H499.75V433.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M499.75 520.5H499.027V521.223H499.75V520.5ZM586.5 519.777H499.75V521.223H586.5V519.777ZM500.473 520.5V433.75H499.027V520.5H500.473Z",
    fill: "white",
    mask: "url(#path-87-inside-44_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-89-inside-45_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M586.5 433.75H673.25V520.5H586.5V433.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M586.5 433.75H673.25V520.5H586.5V433.75Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.5 520.5H585.777V521.223H586.5V520.5ZM673.25 519.777H586.5V521.223H673.25V519.777ZM587.223 520.5V433.75H585.777V520.5H587.223Z",
    fill: "white",
    mask: "url(#path-89-inside-45_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-91-inside-46_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M673.25 433.75H760V520.5H673.25V433.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M673.25 520.5H672.527V521.223H673.25V520.5ZM760 519.777H673.25V521.223H760V519.777ZM673.973 520.5V433.75H672.527V520.5H673.973Z",
    fill: "white",
    mask: "url(#path-91-inside-46_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-93-inside-47_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M760 433.75H846.75V520.5H760V433.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M760 520.5H759.277V521.223H760V520.5ZM846.75 519.777H760V521.223H846.75V519.777ZM760.723 520.5V433.75H759.277V520.5H760.723Z",
    fill: "white",
    mask: "url(#path-93-inside-47_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-95-inside-48_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M846.75 433.75H933.5V520.5H846.75V433.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M846.75 520.5H846.027V521.223H846.75V520.5ZM933.5 519.777H846.75V521.223H933.5V519.777ZM847.473 520.5V433.75H846.027V520.5H847.473Z",
    fill: "white",
    mask: "url(#path-95-inside-48_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-97-inside-49_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.5 520.5H326.25V607.25H239.5V520.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.25 606.527H239.5V607.973H326.25V606.527Z",
    fill: "white",
    mask: "url(#path-97-inside-49_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-99-inside-50_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.25 520.5H413V607.25H326.25V520.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.25 607.25H325.527V607.973H326.25V607.25ZM413 606.527H326.25V607.973H413V606.527ZM326.973 607.25V520.5H325.527V607.25H326.973Z",
    fill: "white",
    mask: "url(#path-99-inside-50_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-101-inside-51_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413 520.5H499.75V607.25H413V520.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M413 607.25H412.277V607.973H413V607.25ZM499.75 606.527H413V607.973H499.75V606.527ZM413.723 607.25V520.5H412.277V607.25H413.723Z",
    fill: "white",
    mask: "url(#path-101-inside-51_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-103-inside-52_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.75 520.5H586.5V607.25H499.75V520.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M499.75 520.5H586.5V607.25H499.75V520.5Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.75 607.25H499.027V607.973H499.75V607.25ZM586.5 606.527H499.75V607.973H586.5V606.527ZM500.473 607.25V520.5H499.027V607.25H500.473Z",
    fill: "white",
    mask: "url(#path-103-inside-52_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-105-inside-53_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M586.5 520.5H673.25V607.25H586.5V520.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M586.5 607.25H585.777V607.973H586.5V607.25ZM673.25 606.527H586.5V607.973H673.25V606.527ZM587.223 607.25V520.5H585.777V607.25H587.223Z",
    fill: "white",
    mask: "url(#path-105-inside-53_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-107-inside-54_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M673.25 520.5H760V607.25H673.25V520.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M673.25 607.25H672.527V607.973H673.25V607.25ZM760 606.527H673.25V607.973H760V606.527ZM673.973 607.25V520.5H672.527V607.25H673.973Z",
    fill: "white",
    mask: "url(#path-107-inside-54_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-109-inside-55_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M760 520.5H846.75V607.25H760V520.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M760 607.25H759.277V607.973H760V607.25ZM846.75 606.527H760V607.973H846.75V606.527ZM760.723 607.25V520.5H759.277V607.25H760.723Z",
    fill: "white",
    mask: "url(#path-109-inside-55_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-111-inside-56_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M846.75 520.5H933.5V607.25H846.75V520.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M846.75 607.25H846.027V607.973H846.75V607.25ZM933.5 606.527H846.75V607.973H933.5V606.527ZM847.473 607.25V520.5H846.027V607.25H847.473Z",
    fill: "white",
    mask: "url(#path-111-inside-56_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-113-inside-57_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.25 607.25H413V694H326.25V607.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.973 694V607.25H325.527V694H326.973Z",
    fill: "white",
    mask: "url(#path-113-inside-57_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-115-inside-58_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413 607.25H499.75V694H413V607.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M413.723 694V607.25H412.277V694H413.723Z",
    fill: "white",
    mask: "url(#path-115-inside-58_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-117-inside-59_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.75 607.25H586.5V694H499.75V607.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M500.473 694V607.25H499.027V694H500.473Z",
    fill: "white",
    mask: "url(#path-117-inside-59_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-119-inside-60_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M586.5 607.25H673.25V694H586.5V607.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M587.223 694V607.25H585.777V694H587.223Z",
    fill: "white",
    mask: "url(#path-119-inside-60_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-121-inside-61_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M673.25 607.25H760V694H673.25V607.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M673.973 694V607.25H672.527V694H673.973Z",
    fill: "white",
    mask: "url(#path-121-inside-61_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-123-inside-62_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M760 607.25H846.75V694H760V607.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M760.723 694V607.25H759.277V694H760.723Z",
    fill: "white",
    mask: "url(#path-123-inside-62_3673_579)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-125-inside-63_3673_579",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M846.75 607.25H933.5V694H846.75V607.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M847.473 694V607.25H846.027V694H847.473Z",
    fill: "white",
    mask: "url(#path-125-inside-63_3673_579)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3673_579)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 586.5,
    cy: 347,
    r: 691.108,
    fill: "url(#paint0_radial_3673_579)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 101,
    width: 56,
    height: 56,
    rx: 8,
    fill: "white",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 116.5,
    y: 101.5,
    width: 55,
    height: 55,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 133.5,
    y: 118.5,
    width: 21,
    height: 21,
    fill: "#FFCA28"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 335,
    width: 56,
    height: 56,
    rx: 8,
    fill: "white",
    fillOpacity: 0.05
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 335.5,
    width: 55,
    height: 55,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0371 357.33C32.9781 353.495 30.4422 351 30.4422 351C30.8196 354.966 26.3595 355.902 25.164 358.627C24.3481 360.486 25.7226 362.115 28.0354 364.167C27.8309 363.712 27.5156 363.27 27.1963 362.823C26.1075 361.298 24.9731 359.71 28.0371 357.33Z",
    fill: "#E76F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8259 365.008C28.8259 365.008 30.3124 363.808 29.1352 362.476C25.1446 357.954 33.4997 355.902 33.4997 355.902C28.3986 358.359 29.1601 359.818 30.4423 361.59C31.8151 363.49 28.8259 365.008 28.8259 365.008Z",
    fill: "#E76F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2028 368.584C37.7817 366.244 35.6646 363.996 34.1869 364.299C33.8247 364.373 33.6632 364.437 33.6632 364.437C33.6632 364.437 33.7976 364.23 34.0545 364.14C36.9779 363.13 39.2262 367.121 33.1107 368.702C33.1107 368.702 33.1816 368.64 33.2028 368.584Z",
    fill: "#5382A1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6748 365.623C20.8098 365.246 25.2456 364.21 25.2456 364.21C25.2456 364.21 23.523 364.096 21.4044 365.103C18.8993 366.295 27.601 366.837 32.1055 365.672C32.5738 365.357 33.2211 365.085 33.2211 365.085C33.2211 365.085 31.3778 365.409 29.5421 365.561C27.2959 365.746 24.8844 365.782 23.6748 365.623Z",
    fill: "#5382A1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7648 367.857C23.1672 367.694 24.2132 366.933 24.2132 366.933C20.0792 368.282 26.5133 369.812 32.2899 368.151C31.6759 367.938 31.2854 367.549 31.2854 367.549C28.4622 368.084 26.8307 368.066 24.7648 367.857Z",
    fill: "#5382A1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4609 370.274C23.8645 370.094 24.7971 369.561 24.7971 369.561C21.0445 370.592 27.0797 372.722 31.8574 370.708C31.0749 370.409 30.5146 370.064 30.5146 370.064C28.3833 370.46 27.3949 370.491 25.4609 370.274Z",
    fill: "#5382A1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.454 371.504C35.454 371.504 36.1442 372.063 34.6939 372.496C31.9361 373.317 23.2157 373.566 20.7932 372.529C19.9224 372.156 21.5554 371.639 22.0691 371.531C22.6048 371.416 22.911 371.438 22.911 371.438C21.9425 370.767 16.6514 372.755 20.2233 373.324C29.9646 374.878 37.9807 372.625 35.454 371.504Z",
    fill: "#5382A1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37 372.726C36.8402 374.771 30.0908 375.201 25.6956 374.925C22.8282 374.744 22.2536 374.292 22.2452 374.285C24.9894 374.73 29.6162 374.811 33.3676 374.117C36.6927 373.501 37 372.726 37 372.726Z",
    fill: "#5382A1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1037,
    y: 141,
    width: 56,
    height: 56,
    rx: 8,
    fill: "white",
    fillOpacity: 0.05
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1037.5,
    y: 141.5,
    width: 55,
    height: 55,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1062.76 158.5C1061.11 158.5 1059.78 159.793 1059.78 161.389V163.389H1064.94V163.944H1057.48C1055.84 163.944 1054.5 165.238 1054.5 166.833L1054.5 171.167C1054.5 172.762 1055.84 174.056 1057.48 174.056H1059.2V171.611C1059.2 170.016 1060.54 168.722 1062.19 168.722H1067.7C1069.09 168.722 1070.22 167.628 1070.22 166.278V161.389C1070.22 159.793 1068.89 158.5 1067.24 158.5H1062.76ZM1062.07 162.056C1062.64 162.056 1063.11 161.608 1063.11 161.056C1063.11 160.503 1062.64 160.056 1062.07 160.056C1061.5 160.056 1061.04 160.503 1061.04 161.056C1061.04 161.608 1061.5 162.056 1062.07 162.056Z",
    fill: "url(#paint1_linear_3673_579)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1067.24 179.5C1068.89 179.5 1070.22 178.206 1070.22 176.611V174.611L1065.06 174.611L1065.06 174.055L1072.52 174.055C1074.16 174.055 1075.5 172.762 1075.5 171.167V166.833C1075.5 165.238 1074.16 163.944 1072.52 163.944L1070.8 163.944V166.389C1070.8 167.984 1069.46 169.278 1067.81 169.278L1062.3 169.278C1060.91 169.278 1059.78 170.372 1059.78 171.722L1059.78 176.611C1059.78 178.206 1061.11 179.5 1062.76 179.5H1067.24ZM1067.93 175.944C1067.36 175.944 1066.89 176.392 1066.89 176.944C1066.89 177.497 1067.36 177.944 1067.93 177.944C1068.5 177.944 1068.96 177.497 1068.96 176.944C1068.96 176.392 1068.5 175.944 1067.93 175.944Z",
    fill: "url(#paint2_linear_3673_579)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 539,
    width: 56,
    height: 56,
    rx: 8,
    fill: "white",
    fillOpacity: 0.05
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 140.5,
    y: 539.5,
    width: 55,
    height: 55,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M172.602 573.954C170.126 575.378 166.723 575.524 163.298 574.062C160.525 572.888 158.225 570.832 156.75 568.483C157.458 569.07 158.284 569.54 159.169 569.951C162.705 571.601 166.241 571.488 168.729 569.955C165.189 567.253 162.177 563.724 159.936 560.847C159.463 560.377 159.11 559.789 158.756 559.261C161.469 561.728 165.776 564.841 167.309 565.722C164.065 562.315 161.174 558.086 161.292 558.203C166.424 563.372 171.203 566.309 171.203 566.309C171.361 566.398 171.483 566.472 171.581 566.538C171.685 566.276 171.775 566.004 171.852 565.722C172.678 562.726 171.734 559.319 169.669 556.5C174.447 559.378 177.279 564.782 176.099 569.305C176.068 569.427 176.035 569.547 175.999 569.666C178.358 572.603 177.751 575.766 177.456 575.179C176.176 572.685 173.806 573.448 172.602 573.954Z",
    fill: "url(#paint3_linear_3673_579)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1108,
    y: 345,
    width: 56,
    height: 56,
    rx: 8,
    fill: "white",
    fillOpacity: 0.05
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 1108.5,
    y: 345.5,
    width: 55,
    height: 55,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1125.5 364L1136 382L1146.5 364H1142.38L1136 374.875L1129.62 364H1125.5Z",
    fill: "#41B883"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1129.62 364L1136 374.875L1142.38 364H1138.62L1136.05 368.509L1133.38 364H1129.62Z",
    fill: "#35495E"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 1048,
    y: 565,
    width: 56,
    height: 56,
    rx: 8,
    fill: "white",
    fillOpacity: 0.05
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1048.5,
    y: 565.5,
    width: 55,
    height: 55,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3673_579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1078.25 582L1067.31 592.943L1070.69 596.329L1085.02 582H1078.25ZM1078.17 592.091L1072.31 597.95L1075.71 601.4L1079.1 598.02L1085.02 592.091H1078.17Z",
    fill: "#47C5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.71 601.4L1078.29 603.973H1085.02L1079.09 598.019L1075.71 601.4Z",
    fill: "#00569E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.28 597.987L1075.66 594.601L1079.09 598.019L1075.71 601.4L1072.28 597.987Z",
    fill: "#00B5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.71 601.4L1078.53 600.466L1078.81 598.305L1075.71 601.4Z",
    fill: "url(#paint4_linear_3673_579)",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3673_579",
    x: -321.483,
    y: -560.983,
    width: 1815.97,
    height: 1815.97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 108.438,
    result: "effect1_foregroundBlur_3673_579"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3673_579",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(586.5 347) rotate(90) scale(691.108)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161618",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46589,
    stopColor: "#161618"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3673_579",
    x1: 1062.36,
    y1: 158.5,
    x2: 1062.36,
    y2: 174.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1565A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3673_579",
    x1: 1067.64,
    y1: 163.944,
    x2: 1067.64,
    y2: 179.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3673_579",
    x1: 167.258,
    y1: 556.5,
    x2: 167.258,
    y2: 575.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F88A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD2020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3673_579",
    x1: 1087.94,
    y1: 681.837,
    x2: 1310.58,
    y2: 762.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3673_579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 694,
    height: 694,
    fill: "white",
    transform: "translate(239.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3673_579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.7666,
    height: 22,
    fill: "white",
    transform: "translate(1067.31 582)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerIllustration);
export default __webpack_public_path__ + "static/media/bannerIllustration.5a81b65cdc8de7e7ec7990bd58e2f62e.svg";
export { ForwardRef as ReactComponent };